import { produce } from 'immer';
import * as actions from '../constants/action-types';

const MAX_LIST_LENGTH_FROM_SERVER = 99;

export default (state = {}, { type, payload }) =>
	produce(state, (draft) => {
		switch (type) {
			case actions.GET_VACANCY_POOL_LIST:
				draft.loading = true;
				draft.loadingMore = payload.start > 0;

				if (payload.start === 0) {
					// Keep showing previous rows until the new result arrives (avoids full-page flash on search)
					draft.hasMoreSubscribers = false;
				}

				break;

			case actions.RECEIVED_VACANCY_POOL_LIST:
				draft.loading = false;
				draft.loadingMore = false;
				draft.hasMoreSubscribers = payload.list.length >= MAX_LIST_LENGTH_FROM_SERVER;

				if (payload.start === 0) {
					draft.list = payload.list;
				} else {
					draft.list = draft.list.concat(payload.list);
				}

				break;

			case actions.VACANCY_POOL_LIST_ERROR:
				draft.loading = false;
				draft.loadingMore = false;
				draft.errors.message = payload.message;

				break;

			case actions.DELETE_VACANCY_POOL_ENTRIES:
				draft.deleting = true;
				draft.deleteStatus = {
					successCount: 0,
					failureCount: 0,
					message: null,
				};
				break;

			case actions.DELETE_VACANCY_POOL_ENTRIES_SUCCESS:
				draft.deleting = false;
				draft.deleteStatus = {
					successCount: payload.successCount,
					failureCount: payload.failureCount,
				};
				break;

			case actions.DELETE_VACANCY_POOL_ENTRIES_ERROR:
				draft.deleting = false;
				draft.deleteStatus = {
					successCount: 0,
					failureCount: 0,
					message: payload.message,
				};
				break;

			case actions.DELETE_VACANCY_POOL_ENTRIES_RESET:
				draft.deleting = false;
				draft.deleteStatus = {
					successCount: 0,
					failureCount: 0,
					message: null,
				};
				break;
		}
	});
